/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const resourceSearchFilterSchema = z.object({
  employmentTypes: z
    .array(z.enum(['EMPLOYEE', 'CONTRACTOR', 'PARTNER', 'ON_DEMAND', 'AI_AGENT']))
    .nullish(),
  holidaySchemeIds: z.array(z.int()).nullish(),
  locationIds: z.array(z.int()).nullish(),
  loopIds: z.array(z.int()).nullish(),
  query: z.string(),
  resourceStatus: z.enum(['ACTIVE', 'DEACTIVATED']).nullish(),
  roleIds: z.array(z.int()).nullish(),
  skillIds: z.array(z.int()).nullish(),
  workloadSchemeIds: z.array(z.int()).nullish(),
});
